export const TICKET_NUMBER_COLUMN = 'Ticket Number';

export interface TicketTableDateRange {
  readonly [key: string]: unknown;
  readonly from: string;
  readonly to: string;
}

export function createAllTimeTicketRange(
  now = new Date(),
): TicketTableDateRange {
  const end = new Date(now);
  end.setHours(23, 59, 59, 999);
  const offset = -end.getTimezoneOffset();
  const sign = offset >= 0 ? '+' : '-';
  const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, '0');
  const minutes = String(Math.abs(offset) % 60).padStart(2, '0');
  const local = new Date(end.getTime() - end.getTimezoneOffset() * 60000)
    .toISOString()
    .replace('Z', '');

  return {
    from: '1970-01-01T00:00:00.000+00:00',
    to: `${local}${sign}${hours}:${minutes}`,
  };
}
